import {useContext} from 'react'
import { ContextoAplicacion } from '../contexto'

export const useModal = () => {
  const contextoApp = useContext(ContextoAplicacion)

  const cerrar = () => {
    contextoApp.setModal({
      abierto: false,
      titulo: '',
      contenido: '',
      botones: [],
    })
  }

  return [cerrar]
}
